import { searchAutoCompleteV2Api } from 'api/search';

export type EmployeeSearchResponse = {
  id: string;
  companyId: string;
  displayName: string;
  profilePhoto: string;
  designation: string;
  ownerType: string;
  employeeFunction: string;
  email: string;
  preferredName: string;
  companyName: string;
};

export type ModuleType =
  | 'MESH_PLATFORM'
  | 'TASK'
  | 'GOAL'
  | 'ONE_ON_ONE'
  | 'ONE_ON_ONE_V2'
  | 'REVIEW'
  | 'ENGAGEMENT'
  | 'COMMENT'
  | 'FEEDBACK'
  | 'POST'
  | 'LEVEL_UP'
  | 'DISCIPLINARY_ACTION';

const getData = async ({ query, limit, moduleType }: { query: string; limit: number; moduleType: ModuleType }) => {
  const res = await searchAutoCompleteV2Api({
    moduleType,
    searchText: query,
    offset: 0,
    limit,
  });

  return res.entity.map(({ id, displayName, profilePhoto, email, companyId, companyName }: EmployeeSearchResponse) => ({
    id,
    label: displayName,
    value: `${'EMPLOYEE_NAME'}_${id}`,
    email,
    profilePhoto,
    companyId,
    companyName,
  }));
};

export const getEmployeesSearchOptions = async (text: string) => {
  try {
    if (text.trim() !== '') {
      const res = await getData({
        query: text ?? '',
        limit: 15,
        moduleType: null,
      });

      return res;
    }
    return [];
  } catch (error) {
    console.error('Error fetching employee search options for text : ', text, ' error : ', error);
    return [];
  }
};
